/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Source_Aria_LabelInputs */

const en_segment_event_group_source_aria_label = /** @type {(inputs: Segment_Event_Group_Source_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select source event group`)
};

const fr_segment_event_group_source_aria_label = /** @type {(inputs: Segment_Event_Group_Source_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner le groupe d'evenements source`)
};

const de_segment_event_group_source_aria_label = /** @type {(inputs: Segment_Event_Group_Source_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quellereignisgruppe auswählen`)
};

const it_segment_event_group_source_aria_label = /** @type {(inputs: Segment_Event_Group_Source_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona il gruppo di eventi di origine`)
};

const ru_segment_event_group_source_aria_label = /** @type {(inputs: Segment_Event_Group_Source_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите группу исходных событий`)
};

const es_segment_event_group_source_aria_label = /** @type {(inputs: Segment_Event_Group_Source_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar el grupo de eventos de origen`)
};

const zh_cn2_segment_event_group_source_aria_label = /** @type {(inputs: Segment_Event_Group_Source_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择源事件组`)
};

const ja_segment_event_group_source_aria_label = /** @type {(inputs: Segment_Event_Group_Source_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソースイベントグループを選択`)
};

const hi_segment_event_group_source_aria_label = /** @type {(inputs: Segment_Event_Group_Source_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्रोत घटना समूह का चयन करें`)
};

const pt_pt2_segment_event_group_source_aria_label = /** @type {(inputs: Segment_Event_Group_Source_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o grupo de eventos de origem`)
};

/**
* | output |
* | --- |
* | "Select source event group" |
*
* @param {Segment_Event_Group_Source_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_source_aria_label = /** @type {((inputs?: Segment_Event_Group_Source_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Source_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_source_aria_label(inputs)
	if (locale === "de") return de_segment_event_group_source_aria_label(inputs)
	if (locale === "it") return it_segment_event_group_source_aria_label(inputs)
	if (locale === "ru") return ru_segment_event_group_source_aria_label(inputs)
	if (locale === "es") return es_segment_event_group_source_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_source_aria_label(inputs)
	if (locale === "ja") return ja_segment_event_group_source_aria_label(inputs)
	if (locale === "hi") return hi_segment_event_group_source_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_source_aria_label(inputs)
	return en_segment_event_group_source_aria_label(inputs)
});